import { FC, memo } from 'react';
import cx from 'clsx';

import { Icon } from '../Icon';

import styles from './styles.module.css';

const redirectUrl = 'https://playwall.co/';

export const Footer: FC = memo(() => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.socials}>
        <a
          className={cx(styles.socialLink, styles.instagramLink)}
          href="https://www.instagram.com/playwall.kezerk/"
          target="_blank"
        >
          <Icon name="instagram" />
        </a>
        <a
          className={cx(styles.socialLink, styles.mailLink)}
          href="mailto:contact@playwall.co"
          target="_blank"
        >
          <Icon name="mail" />
        </a>
      </div>
      <a className={styles.button} href={redirectUrl} target="_blank">
        <span className={styles.buttonText}>LEARN MORE ABOUT US </span>
        <div className={styles.buttonIcon}>
          <Icon name="arrowRight" />
        </div>
      </a>
      <span className={styles.copyright}>
        {currentYear} PlayWall. All rights reserved
      </span>
    </footer>
  );
});
